import {ChecklistStatus, ChecklistTemplateKind} from '@domain/hroc-checklists'

export const HROC_CHECKLISTS_WIDGET_NAMESPACE = 'widget.hroc-checklists'

export const HROC_CHECKLIST_KIND_TRANSLATION_KEYS: Record<ChecklistTemplateKind, string> = {
  take5: 'checklist.templateKind.take5',
  kilnChecksheet: 'checklist.templateKind.kilnCheckSheet'
}

export const HROC_CHECKLIST_STATUS_TRANSLATION_KEYS: Record<ChecklistStatus, string> = {
  pending: 'checklist.status.pending',
  done: 'checklist.status.done'
}
